import {isFeatureEnabled} from 'feature-flags';
import {match} from 'ts-pattern';

import {always} from 'ramda';

import {EntityResourceIds} from '@dms/api/shared';
import {featureFlags} from '@dms/feature-flags';

export const isEntityFeatureFlagEnabled = (resourceId: EntityResourceIds) =>
  match(resourceId)
    .with(EntityResourceIds.interest, () => isFeatureEnabled(featureFlags.INTEREST_CUSTOM_FIELDS))
    .with(EntityResourceIds.employee, () => isFeatureEnabled(featureFlags.EMPLOYEE_CUSTOM_FIELDS))
    .otherwise(always(true));
